// extracted by mini-css-extract-plugin
export default {"bg_image":"Carousel_bg_image__Ut-gf"};